<script>
import { layoutMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
//import flatPickr from "vue-flatpickr-component";
//import "flatpickr/dist/flatpickr.css";
import { vcRewardsComputed, vcRewardsMethods } from "@/state/helpers"
// import { stat } from "fs";
import Swal from 'sweetalert2';
import Multiselect from "vue-multiselect";
//import shortid from "shortid";


/**
 * E-Load list component
 */
export default {
  page: {
    title: "Blvck Coins Give Rewards"
  },
  props: ["id", "businessName"],
  data() {
    return {
      vcRewardsForm: {
        amount:null,
        type:null,
        note:null,
      },
      formExitChecker: {
        amount:null,
        type:null,
        note:null,
      },
      typeOptions:[
        {"value":"sales","name":"Sales"},
        {"value":"giveaway","name":"Giveaway"},
        {"value":"test","name":"Test"}
      ],
      isLoading: false,
      config: {
        enableTime: true,
        dateFormat: "m-d-Y H:i",
        maxDate: new Date()
      },
      submitted: false,
      eloadRewardFile: {
        filename: null,
        type: null,
        base64: null
      },
      createModal: false,
    };
  },
  validations: {
    vcRewardsForm: {
      amount:{required},
      type:{required}
      // note:{required}
    },
  },
  components: {
   // flatPickr,
    Multiselect,
  },
  computed: {
    ...vcRewardsComputed,
  },
  async mounted() {
    console.log(`"BizID: ${this.id} Name: ${this.businessName}`);
    this.changeTitle({title: 'Blvck Coins Add Reward'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'BLVCK Coins', to: { name: 'Blvck Coins'}},
        { text: 'Add Rewards', to: { name: 'Blvck Coins Add Rewards'}},
      ]
    });
  },
  methods: {
    ...layoutMethods,
    ...vcRewardsMethods,
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
    isNumber ($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }else{
          // console.log(">>>>>",this.vcRewardsForm.amount);
      }
    },
    clearAll () {
      this.vcRewardsForm = {
        amount:null,
        type:null,
        note:null,
      }
    },
    async handleSubmit() {      
      // alert("Form submit");
      this.submitted = true
      this.$v.$touch();
      let self = this;
      console.log("submit",this.vcRewardsForm.amount);

      if (!this.$v.vcRewardsForm.$invalid){
        console.log("check");
        Swal.fire({
          title: "<h2 style='color: #E63493; padding-top:50 px;'>Review Top up details</h5><hr>",
          html: `<div class="swal-send-html">You are about to top up blvck coins. Review the Details below:
                <br><br><br>
                  Store: <strong>${this.businessName}</strong><br>
                  Amount: <strong>${this.vcRewardsForm.amount}</strong><br>
                  Type: <strong>${this.vcRewardsForm.type.name}</strong><br>
                  Notes: <strong>${this.vcRewardsForm.note}</strong></div>`,
          
          showCancelButton: true,
          cancelButtonText: "Back",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Proceed",
        }).then(async (result) => {
          if (result.value) {
            await this.addUserVC({amount: this.vcRewardsForm.amount, businessId: this.id, note: this.vcRewardsForm.note , type: this.vcRewardsForm.type.value})
            .then(function(res){
              Swal.fire({
                title: "<h2> Top up <span style='color: #E63493; padding-top:50 px;'>Successful</span></h2><hr>",
                html: `<div class="swal-send-html">
                        Store: <strong>${self.businessName}</strong><br>
                        Amount: <strong>${self.vcRewardsForm.amount}</strong><br>
                        Type: <strong>${self.vcRewardsForm.type.name}</strong><br>
                        Notes: <strong>${self.vcRewardsForm.note}</strong></div>`,
                icon: "success",
                showCloseButton: true,
                showConfirmButton: false
              }).then(async () => {
                self.clearAll();
                self.$router.back();
              });
              
              console.log("check:",res);
            })
            .catch(function(e){
                Swal.fire("Loading Failed!", `${e}`, "error");
            });
          }
        });
        // alert("clean");
        // console.log(">> data:", JSON.stringify(this.eloadRewardsForm))
      }
    
    },
   
        
    compareStr(data, arr_similar){// case insensitive string comparison
      for(var i = 0; i < arr_similar.length; i++){
          var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
            if(areEqual){
              return areEqual;
            }
        }
        return false;
    },
    openCreateModal(){
      this.createModal = true;
    },
    leaveform(next){
        console.log(this.vcRewardsForm,this.formExitChecker);
        if(JSON.stringify(this.vcRewardsForm) == JSON.stringify(this.formExitChecker)){
            next();
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
   
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",JSON.stringify(this.vcRewardsForm),JSON.stringify(this.formExitChecker));
      if(JSON.stringify(this.vcRewardsForm) != JSON.stringify(this.formExitChecker)){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <h2><span style="color: #C3297C;">{{businessName}}</span> Store</h2>
                    <!-- <span class="text-muted fw-normal ms-2">{{userListTotalRows}}</span>
                    Record(s) -->
                  </h5>
                </div>
              </div>
              <!-- end col -->
             
              <!-- Search and button -->
              <form class="px-4" @submit.prevent="handleSubmit()">
                <div class="row mb-2 px-3">
                  <b-col sm="6" class="mb-3">
                    <label class="form-label small fw-bold">Amount<span style="color: red">*</span></label>
                    <div class="input-group">
                      <b-form-input
                        @keypress="isNumber($event)"
                        type="number"
                        step="0.01"
                        class="form-control"
                        v-model="vcRewardsForm.amount"
                        placeholder="0.00"
                        :class="{
                            'is-invalid': submitted && $v.vcRewardsForm.amount.$error,
                        }"
                      />
                    </div>
                    <div v-if="submitted && $v.vcRewardsForm.amount.$error"
                      class="text-danger">
                      <span v-if="!$v.vcRewardsForm.amount.required">This value is required.</span>
                      <!-- <span v-if="!$v.vcRewardsForm.amount.maxValue">This value should be lower than or equal to 500.</span> -->
                    </div>
                    <!-- <div>
                      <label class="form-label fs-12">This value should be lower than or equal to 500.</label>
                    </div> -->
                  </b-col>
                  <div class="col-md-6 mb-3">
                    <label class="form-label small fw-bold">Type<span style="color: red">*</span></label>
                    <multiselect 
                      v-model="vcRewardsForm.type" 
                      deselect-label="Can't remove this value" 
                      track-by="value" label="name" 
                      placeholder="Select type here..." 
                      :options="typeOptions" 
                      :searchable="false" 
                      :allow-empty="false"
                      :class="{
                          'is-invalid': submitted && $v.vcRewardsForm.type.$error,
                      }">
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.name }}</strong>
                      </template>
                    </multiselect>
                    <div v-if="submitted && $v.vcRewardsForm.type.$error"
                      class="text-danger">
                      <span v-if="!$v.vcRewardsForm.type.required">This value is required.</span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <template>
                      <div>
                        <label class="form-label">Note</label>
                        <b-form-textarea
                          id="textarea"
                          v-model="vcRewardsForm.note"
                          placeholder="Enter note here..."
                          rows="3"
                          max-rows="6"
                        ></b-form-textarea>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="row mt-3 mb-2 px-3">
                  <div class="col-md-6 mt-3">
                    <b-button variant="primary" class="w-sm w-100p" type="submit">Send</b-button>
                  </div>
                  <div class="col-md-6 mt-3">
                    <router-link :to="{ name: 'Blvck Coins', params: {} }" class="tc-white">
                      <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
            <!-- end col -->
            <!-- end row -->

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.swal-send-html {
  text-align: left;
}
.custom-checkbox-method label {margin-left: 10px;}
.custom-checkbox-method input {margin-left: 15px;}
.required-input {color:red;}
.calendar-icon {display: block;font-size: 20px;padding: 8px;background-color: grey;}
.custom__tag{
    padding: 1px 5px;
    background: #E73092;
    color: #FFF;
    border-radius: 10px;
    margin-right: 5px;
}
.custom__remove{
  cursor: pointer;
}
.fs-12{
  font-size: 12px;
}

</style>